export const regexAddComma = (val) => {
    return val?.replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Menambahkan koma sebagai pemisah ribuan
}
export const regexRemoveComma = (val) => {
   return val?.replace(/\$\s?|(,*)/g, '') // Menghapus format untuk mendapatkan angka murni
}